// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive Layout Styles for Order Dashboard */

/* Hide desktop view on mobile */
@media (max-width: 768px) {
  .desktop-order-dashboard {
    display: none !important;
  }
  
  /* Remove padding from dashboard container for mobile */
  .dashboard-container,
  .main-content,
  .content-page,
  .container-fluid {
    padding: 20px 8px;
    margin: 0 !important;
  }
}

/* Hide mobile view on desktop */
@media (min-width: 769px) {
  .mobile-order-dashboard {
    display: none !important;
  }
}

/* Tablet adjustments */
@media (min-width: 769px) and (max-width: 1024px) {
  .mobile-order-dashboard {
    display: none !important;
  }
  
  /* Adjust desktop layout for tablets if needed */
  .desktop-order-dashboard .card {
    font-size: 14px;
  }
}

/* Small mobile devices */
@media (max-width: 375px) {
  .mobile-items-grid {
    grid-template-columns: 1fr !important;
  }
  
  .mobile-order-type-btn {
    min-width: 90px;
    padding: 10px 15px;
    font-size: 12px;
  }
  
  .mobile-header {
    padding: 12px 15px;
  }
}

/* Large screens */
@media (min-width: 1920px) {
  .mobile-order-dashboard {
    display: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/OrderDashboard/ResponsiveOrderDashboard.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,gCAAgC;AAChC;EACE;IACE,wBAAwB;EAC1B;;EAEA,uDAAuD;EACvD;;;;IAIE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,wBAAwB;EAC1B;;EAEA,gDAAgD;EAChD;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Responsive Layout Styles for Order Dashboard */\n\n/* Hide desktop view on mobile */\n@media (max-width: 768px) {\n  .desktop-order-dashboard {\n    display: none !important;\n  }\n  \n  /* Remove padding from dashboard container for mobile */\n  .dashboard-container,\n  .main-content,\n  .content-page,\n  .container-fluid {\n    padding: 20px 8px;\n    margin: 0 !important;\n  }\n}\n\n/* Hide mobile view on desktop */\n@media (min-width: 769px) {\n  .mobile-order-dashboard {\n    display: none !important;\n  }\n}\n\n/* Tablet adjustments */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .mobile-order-dashboard {\n    display: none !important;\n  }\n  \n  /* Adjust desktop layout for tablets if needed */\n  .desktop-order-dashboard .card {\n    font-size: 14px;\n  }\n}\n\n/* Small mobile devices */\n@media (max-width: 375px) {\n  .mobile-items-grid {\n    grid-template-columns: 1fr !important;\n  }\n  \n  .mobile-order-type-btn {\n    min-width: 90px;\n    padding: 10px 15px;\n    font-size: 12px;\n  }\n  \n  .mobile-header {\n    padding: 12px 15px;\n  }\n}\n\n/* Large screens */\n@media (min-width: 1920px) {\n  .mobile-order-dashboard {\n    display: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
